var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combine, createEvent, createStore, restore, sample } from "effector";
import { nanoid } from "nanoid";
export var setPlayerTrackQueue = createEvent();
export var resetPlayerTrackQueue = createEvent();
export var setPlayerCurrentTrackSourceIndex = createEvent();
export var setPlayerCurrentTrackIndex = createEvent();
export var playerShuffleToggled = createEvent();
export var setPlayerTracksSourceTracks = createEvent();
export var resetPlayerCurrentTrackIndexAndTrackSourceIndex = createEvent();
export var $playerTrackQueue = createStore(null);
$playerTrackQueue.reset(resetPlayerTrackQueue);
export var $currentTrackSourceIndex = restore(setPlayerCurrentTrackSourceIndex, 0);
export var $playerCurrentTrackSource = combine($playerTrackQueue, $currentTrackSourceIndex, function (queue, index) { return (queue ? queue[index] : null); });
export var $playerCurrentTrackSourceId = $playerCurrentTrackSource.map(function (trackSource) { var _a; return (_a = trackSource === null || trackSource === void 0 ? void 0 : trackSource.trackSourceId) !== null && _a !== void 0 ? _a : null; });
export var $playerCurrentTrackIndex = restore(setPlayerCurrentTrackIndex, 0);
export var $playerCurrentTrack = combine($playerCurrentTrackSource, $playerCurrentTrackIndex, function (trackSource, index) {
    return trackSource && trackSource.tracks && trackSource.tracks[index]
        ? trackSource.tracks[index]
        : null;
});
export var $playerNextTrack = combine($playerTrackQueue, $currentTrackSourceIndex, $playerCurrentTrackIndex, function (queue, trackSourceIndex, trackIndex) {
    var _a;
    if (!queue)
        return null;
    if (!queue[trackSourceIndex].tracks)
        return null;
    return (_a = queue[trackSourceIndex].tracks[trackIndex + 1]) !== null && _a !== void 0 ? _a : null;
});
export var $playerPreviousTrack = combine($playerTrackQueue, $currentTrackSourceIndex, $playerCurrentTrackIndex, function (queue, trackSourceIndex, trackIndex) {
    var _a;
    if (!queue)
        return null;
    if (!queue[trackSourceIndex].tracks)
        return null;
    return (_a = queue[trackSourceIndex].tracks[trackIndex - 1]) !== null && _a !== void 0 ? _a : null;
});
export var $playerHasCurrentTrack = $playerCurrentTrack.map(function (track) { return !!track; });
export var $playerHasNextTrack = combine($playerNextTrack, $playerCurrentTrackSource, function (nextTrack, trackSource) {
    var _a;
    return Boolean(nextTrack) ||
        ((trackSource === null || trackSource === void 0 ? void 0 : trackSource.type) === "playlist" && Boolean((_a = trackSource.tracks) === null || _a === void 0 ? void 0 : _a.length));
});
export var $playerHasPreviousTrack = $playerPreviousTrack.map(function (track) { return !!track; });
export var $playerCurrentTrackId = $playerCurrentTrack.map(function (track) { var _a; return (_a = track === null || track === void 0 ? void 0 : track.id) !== null && _a !== void 0 ? _a : null; });
export var $currentPlayerTrackQueueState = combine({
    currentPlayerTrackSource: $playerCurrentTrackSource,
    currentPlayerTrackIndex: $playerCurrentTrackIndex,
});
export var $playerShuffleEnabled = createStore(false);
$playerShuffleEnabled.on(playerShuffleToggled, function (enabled) { return !enabled; });
$playerTrackQueue.on(setPlayerTrackQueue, function (_, payload) {
    return Array.isArray(payload)
        ? payload.map(function (item) { return (__assign(__assign({}, item), { trackSourceId: nanoid() })); })
        : [__assign(__assign({}, payload), { trackSourceId: nanoid() })];
});
$currentTrackSourceIndex.reset(resetPlayerCurrentTrackIndexAndTrackSourceIndex);
$playerCurrentTrackIndex.reset(resetPlayerCurrentTrackIndexAndTrackSourceIndex);
sample({
    clock: setPlayerTracksSourceTracks,
    source: $playerTrackQueue,
    fn: function (playerTrackQueue, _a) {
        var _b;
        var tracks = _a.tracks, trackSourceId = _a.trackSourceId;
        return (_b = playerTrackQueue === null || playerTrackQueue === void 0 ? void 0 : playerTrackQueue.map(function (trackSource) {
            if (trackSource.trackSourceId === trackSourceId) {
                return __assign(__assign({}, trackSource), { tracks: tracks });
            }
            return trackSource;
        })) !== null && _b !== void 0 ? _b : null;
    },
    target: $playerTrackQueue,
});
